import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledOnePagerAssetContentComponent = styled.div`
  width: 100vw;
  height: calc(100vh - 65px);
  position: relative;
  overflow: hidden;

  .desktop-content-wrapper {
    display: block;
    height: 100%;
  }

  .mobile-content-wrapper {
    display: none;
    height: 100%;
  }

  &.multiple-folds {
    overflow: visible;

    .desktop-content-wrapper {
      height: auto;

      .desktop-content-component {
        .asset-part-wrapper {
          .asset-part-component {
            .video-component {
              .react-player-video-component {
                video {
                  width: 100vw !important;
                  height: calc(100vh - 65px) !important;
                  object-fit: cover;
                }
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    height: calc(100vh - 54px);

    .desktop-content-wrapper {
      display: none;
    }

    .mobile-content-wrapper {
      display: block;
    }
  }
`;
